import { useState } from 'react';
import { isSmartPhone } from '../../utilities/helper';
import { homePageTabRoutes } from '../../constants/dashboard';
import MatchTabHomeMWeb from './index_mWeb';
import MatchTabHomeWeb from './index_web';
import { useSelector } from 'react-redux';

const MatchTabHome = () => {
  const [routes] = useState(homePageTabRoutes);
  const { miniGamesList = [] } = useSelector((state: any) => state.minigames);
  const quizGames = miniGamesList.filter((item: any) => item.category === 'quiz');
  const sportsGames = miniGamesList.filter((item: any) => item.category === 'sports');
  const arcadeGames = miniGamesList.filter((item: any) => item.category === 'arcade');
  const racingGames = miniGamesList.filter((item: any) => item.category === 'racing');
  const puzzleGames = miniGamesList.filter((item: any) => item.category === 'puzzles');
  const strategyGames = miniGamesList.filter((item: any) => item.category === 'strategy');

  return (
    <>
      {isSmartPhone ? (
        <MatchTabHomeMWeb gameTypes={routes} />
      ) : (
        <MatchTabHomeWeb
          gameTypes={routes}
          quizGames={quizGames}
          sportsGames={sportsGames}
          arcadeGames={arcadeGames}
          racingGames={racingGames}
          puzzleGames={puzzleGames}
          strategyGames={strategyGames}
        />
      )}
    </>
  );
};

export default MatchTabHome;
